import { i18n } from '@/plugins/i18n'

export const ivrStatus = {
    ACTIVE: 1,
    PENDING: 2,
    REJECTED: 3,
    BLOCKED: 4,
}

export const ivrStatusStr = {
    ACTIVE: i18n.t('payman_status.active'),
    PENDING: i18n.t('payman_status.pending'),
    REJECTED: i18n.t('payman_status.rejected'),
    BLOCKED: i18n.t('payman_status.blocked'),
    get(status) {
        let status_str = null;
        Object.keys(ivrStatus).forEach(function (item) {
            if(ivrStatus[item] === status) {
                status_str = ivrStatusStr[item]
            }
        })

        return status_str
    }
}

export const ivrVariant = (status) => {
    if(status === ivrStatus.ACTIVE) {
        return 'success'
    }

    if(status === ivrStatus.REJECTED || status === ivrStatus.BLOCKED) {
        return 'danger'
    }

    if(status === ivrStatus.PENDING) {
        return 'warning'
    }

    return 'info'
} 